import axios from 'axios'
import Qs from 'qs'

const apiClient = axios.create({
    // create single axios instance for entire app
    baseURL: '/webservice', // base URL to call
    timeout: 10000,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    }
})

export default {
    getCustomersCustomFields (calenderid) {
        return apiClient.get('/get/customers_customfields', {
                params: {
                    'company-id': calenderid
                }
            }
        )
    },
    getServices (calenderid) {
        return apiClient.get('get/booker-services_companies', {
                params: {
                    'company_id': calenderid
                }
            }
        )
    },
    getTimeSlots (date, calenderid, services) {
        return apiClient.get('/get/booker-services_availabilities', {
            params: {
                'company_id': calenderid,
                'service_id': services,
                'days[]': date,
            }
        })
    },
    createReservation (calenderid, services, date, time) {
        return apiClient.post('/post/booker-services_reservations', {
            'company_id': calenderid,
            'service_id': services,
            'date': date,
            'time': time,
        })
    },
    deleteReservation (calenderid, reservation_id , secret , reason) {
        return apiClient.post('/delete/booker-services_reservations_'+ reservation_id, {
            'company_id': calenderid,
            'secret': secret,
            'reason': reason,
        })
    },
    postAppointement (company_id ,reservation_id , secret , fields) {
        return apiClient.post('/post/booker-services_appointments_confirm', {
            'reservation_id': reservation_id,
            'company_id': company_id,
            'secret': secret,
            'fields':fields,
        })
    },
    getAppointement (appid ,calenderid) {
        return apiClient.get('/get/appointments_'+ appid, {
                params: {
                    'company-id': calenderid
                }
            }
        )
    },
    deleteAppointement (appid ,calenderid) {
        return apiClient.post('/delete/appointments_'+ appid, {
            'company-id': calenderid
        })
    }
}
